<div class="table-display-mode flex flex--align-center flex--nowrap">
  <span class="table-display-mode__title text--small">{{ 'app.catalog.table.displaymode.title' | translate }}</span>
  <mat-radio-group [formControl]="control" class="table-display-mode__radio">
    <mat-radio-button color="primary" value="list">{{ 'app.catalog.table.displaymode.list' | translate }}</mat-radio-button>
    <mat-radio-button color="primary" value="grid">{{ 'app.catalog.table.displaymode.grid' | translate }}</mat-radio-button>
  </mat-radio-group>
</div>
